import { Routes } from '@angular/router';

import { GuestGuard } from "../guards/guest.guard";

export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '',
        canActivate: [GuestGuard],
        loadComponent: () => import('./forgot-password.component').then(m => m.ForgotPasswordComponent)        
      }
    ]
  }
];
